module.exports = __webpack_public_path__ + "media/images/calendar-fb15d07b46d7ddc98177b094f6528182.svg";